import { render, staticRenderFns } from "./IncomeBreakdownChart.vue?vue&type=template&id=58ddb26e&"
import script from "./IncomeBreakdownChart.vue?vue&type=script&lang=js&"
export * from "./IncomeBreakdownChart.vue?vue&type=script&lang=js&"
import style0 from "./IncomeBreakdownChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports